import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core'
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { DomSanitizer } from '@angular/platform-browser'
import { environment } from '../../../environments/environment'
import { StoreService } from '../../service/store.service'
import { CpmService } from '../../service/cpm.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { AuthorizeService } from '../../service/authorize.service'
import { ToastrService } from '../../../../node_modules/ngx-toastr';
@Component({
  selector: 'app-additional-info-competitor',
  templateUrl: './additional-info-competitor.component.html',
  styleUrls: ['./additional-info-competitor.component.scss']
})
export class AdditionalInfoCompetitorComponent implements OnInit {
  @Input() companyProfile: any
  @Input() printPage
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  @ViewChild('template') template: TemplateRef<any>
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }
  dataType = 'Competitor'
  subscription: Subscription
  securitySymbol
  companyStructureFilename
  companyIdPsims
  testLink
  text
  newText
  checkModified = false
  showTextWhenNull
  checkUpdate = false
  checkNulltext = false
  checkDis = false
  checkNullImg = false
  who
  postioning
  anyInfo
  competitor
  checkImgSubmit = false
  isAE
  message
  constructor(
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.who = '- Who is your competitors (can be listed or non listed)'
    this.postioning = '- Postioning compare to competitors'
    this.anyInfo = '- Any information related to competitors'
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.companyIdPsims = response['companyIdPsims']
        this.securitySymbol = response['securitySymbol']
        this.text = response['competitor']
        this.competitor = response['competitorFilename']
        this.testLink = `${environment.cpmBaseUrl}/download?type=${this.dataType}&id=${this.companyIdPsims}`
        this.isAE = response['ae']
        this.onChangeData()
      })
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  checkNullText() {
    if (this.text === null || this.text === '') {
      this.checkNulltext = true
    } else {
      this.checkNulltext = false
    }
  }

  async onChangeData() {
    this.checkNullText();
    if (this.competitor === null) {
      this.checkNullImg = true
    } else {
      this.checkNullImg = false
    }
    this.newText = this.text
  }
  modifiedText() {
    return (this.checkModified = true)
  }
  checkDisplay() {
    return (this.checkDis = true)
  }

  checkCancel() {
    this.newText = this.text
    return (this.checkUpdate = false), (this.checkDis = false)
  }

  checkSubmit() {
    this.text = this.newText;
    this.updateToSecprofile()
    this.checkNullText();
    return (this.checkUpdate = true), (this.checkDis = false)
  }

  async updateToSecprofile() {
    const body = {
      companyId: this.companyIdPsims,
      fieldName: 'competitor',
      fieldValue: this.text
    }
    await this.cpmService.updateCompanyProfile(body).then(response => {
      this.message = response.status
      this.message === 'OK' ? (this.toastr.success('การบันทึกรายการสำเร็จแล้ว')) : (this.message = 'บันทึกรายการไม่สำเร็จ')
    },
      error => {
        this.message = 'บันทึกรายการไม่สำเร็จ'
        this.openModalError(this.templateSaved)
      })
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
  }

  closeModal() {
    this.modalRef.hide()
  }

  openImg() {
    window.open(this.testLink)
  }

  getLink(companyIdPsims) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=${this.dataType}&id=${companyIdPsims}&srcImg=${new Date().getTime()}`
    )
  }

  testClick(symbol) {
    this.competitor = symbol
    this.checkImgSubmit = true
    this.checkNullImg = false
  }

  reupload() {
    $('#upload').click()
  }

  openModalError(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }

  uploadFile() {
    const width = 600
    const height = 600
    const left = screen.width / 2 - width / 2
    const top = screen.height / 2 - height / 2
    this.openModal(this.template)
  }
  clickEditDropdown(event: Event) {
    $(event.target)
      .closest('div')
      .next()
      .toggleClass('show')
  }

  mourseLeaveMenu() {
    $(event.target)
      .find('#editItemListAdditionlCom')
      .removeClass('show')
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/additional-info-competitor/additional-info-competitor.component.ts